/**
 * Query to fetch marketplace_orgs with their seller links
 * Used to build a reverse lookup map from seller ID to org
 * Limited to 2000 to prevent performance issues
 */
const allOrgsWithSellersQuery = `
query AllMarketplaceOrgsWithSellers($first: Int!) {
  marketplace_orgs(first: $first, where: { marketplace_seller_pointer: { exists: true } }) {
    count
    edges {
      node {
        objectId
        name
        city
        marketplace_seller_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default allOrgsWithSellersQuery;
